import React, { type ReactElement, useEffect, useState } from 'react';

import type { IndexResponse } from '~/types/responses';

import type { Model } from '~/types/models';
import type { StringKeys } from '~/types/utils';

interface ILabelResolverProps<T> {
  labelKey: string;
  promise: Promise<IndexResponse<T>>;
  type: string;
  value: string;
}

export default function LabelResolver<T extends Model>({
  labelKey,
  promise,
  type,
  value,
}: ILabelResolverProps<T>): ReactElement {
  useEffect(() => {
    promise.then((response) => {
      const item = response.items.find((i) => i.id === value);
      const label = item ? (item[labelKey as StringKeys<T>] as string) : '';
      const defaultLabel = `${type} (${value})`;
      setLabel(`${label ?? defaultLabel}`);
    });
  }, [value]);

  const [label, setLabel] = useState<string>('...');

  return <span className='LabelResolver'>{label}</span>;
}
